import type { FeedMessage } from "@/types";
import { compareFeedCursor } from "@/utils/messageId";

export function sortFeedMessages(messages: FeedMessage[]): FeedMessage[] {
  return [...messages].sort((a, b) => compareFeedCursor(a, b));
}
